import _ from 'lodash';

import { formatNumberToFixed3Decimals } from 'utils/number';

import { NIL_OR_NAN_DEFAULT_PLACEHOLDER } from './LoanInfoModal.constant';

export const getMergedShallowObjectsMemoized = (...objects) =>
  objects.reduce((result, obj) => (_.isObject(obj) ? { ...result, ...obj } : result), {});

export const getValueWithNilOrNaNPlaceholder = (
  value,
  placeholder = NIL_OR_NAN_DEFAULT_PLACEHOLDER,
) => (_.isNil(value) || _.isNaN(value) ? placeholder : formatNumberToFixed3Decimals(value));
